/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMaximizeOff = createReactComponent("maximize-off", "IconMaximizeOff", [
  ["path", { d: "M4 8v-2c0 -.551 .223 -1.05 .584 -1.412", key: "svg-0" }],
  ["path", { d: "M4 16v2a2 2 0 0 0 2 2h2", key: "svg-1" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "svg-2" }],
  ["path", { d: "M16 20h2c.545 0 1.04 -.218 1.4 -.572", key: "svg-3" }],
  ["path", { d: "M3 3l18 18", key: "svg-4" }]
]);

export { IconMaximizeOff as default };
//# sourceMappingURL=IconMaximizeOff.js.map
